import Paper from "paper/dist/paper-core";
import { useEffect, useRef } from "react";

export function usePaper(debug: boolean) {
  const paperScopeRef = useRef<paper.PaperScope | null>(null);
  useEffect(() => {
    paperScopeRef.current = new Paper.PaperScope();
    if (debug) {
      new Paper.Tool();
      paperScopeRef.current.setup("paper-canvas");
    } else {
      paperScopeRef.current.setup(new Paper.Size([1, 1]));
      paperScopeRef.current.view.autoUpdate = false;
    }
  }, [debug]);

  return () => {
    if (debug && paperScopeRef.current !== null) {
      paperScopeRef.current.project.activeLayer.removeChildren();
    }
  };
}
